import { useEffect } from 'react';
import { useRouter } from '~/utils/navigation';
import { notificationDetailPageOpened, notificationClickToMyNotificationsDetailPageCTA } from '@comeon/analytics';
import { Collapse, MotionIconWrapper, variantsRotate } from '@comeon/ui';
import Icon, { ICON_BOTTOM } from '~/components/icon/index.js';
import useTranslations from '~/components/translation/use-translations.ts';
import ButtonWrapper from '~/components/misc/button-wrapper.js';
import { Sidebar, SidebarContent } from '~/components/sidebar/index.js';
import handleCTAClick from './my-notifications-utils.js';
import IconArrowLinkLeft from '~/components/misc/icon-arrow-link-left.js';
import usePreprocess from './utils/usePreprocess.js';
import useBasePathname from '~/hooks/use-base-pathname';
// import TextWithEmbedData from './utils/text-with-embed-data.js';
import RichTextRenderer from './rich-text-renderer';

const NotificationDetail = ({ item }) => {
	const _item = usePreprocess(item);
	// DataLayer Tracking
	// Notification Detail Page Trigger when notification additional screen is viewed
	useEffect(() => {
		notificationDetailPageOpened(
			`${_item.recurringNotificationId ? `r${_item.recurringNotificationId} - ` : ''}${_item.id} - ${_item.title}`
		);
	}, [_item.id, _item.title, _item.recurringNotificationId]);

	const router = useRouter();

	const textKeys = ['NOTIFICATION_DETAIL_EXPIRY_DATE', 'NOTIFICATIONS_TC_EXAMPLE'];

	const { translations, isLoadingTranslations } = useTranslations(textKeys);

	const basePathname = useBasePathname();

	if (!_item) {
		return null;
	}

	return isLoadingTranslations ? null : (
		<Sidebar>
			<SidebarContent>
				<div className="notification-detail-container">
					<div className="page-head image-header-container">
						<div className="page-head__left-side">
							<IconArrowLinkLeft
								href="/account/my-notifications"
								className="back js-back page-head__back u-show"
								data-at="backbutton-my-notifications-detail"
							/>
						</div>
					</div>
					{_item.image && <img className="detail-image" alt="" src={_item.image} />}

					<div>
						{/* Title */}
						<RichTextRenderer
							data={_item.title}
							key="title"
							additionalClassName="title"
							additionalClassNameEditor="title_editor"
						/>
						{/* Description */}
						<RichTextRenderer
							data={_item.description}
							key="description"
							additionalClassName="description"
							additionalClassNameEditor="description_editor"
						/>
					</div>
					{_item.data && (
						<>
							{/* user end date */}
							{_item.data.DisplayedEndDate && (
								<ul className="data-list">
									<li className="list-item" key="Displayed End Date">
										<b>{translations.NOTIFICATION_DETAIL_EXPIRY_DATE}</b>
										<div className="u-notification-end-date">
											{new Date(_item.data.DisplayedEndDate).toLocaleDateString()}{' '}
											{new Date(_item.data.DisplayedEndDate).toLocaleTimeString([], {
												hour: '2-digit',
												minute: '2-digit',
												hour12: false
											})}
										</div>
									</li>
								</ul>
							)}
							{/* accordion */}
							{_item.data.Accordion && (
								<Collapse
									className="my-notification-accordion-wrapper"
									renderTitle={() => (
										<>
											<RichTextRenderer
												data={_item.data.Accordion.accordion_title}
												key="accordion-title"
												additionalClassName="accordion-title"
												additionalClassNameEditor="accordion-title_editor"
											/>
											<MotionIconWrapper
												initial="down"
												variants={variantsRotate}
												animate="down"
												transition={{
													x: { type: 'spring', stiffness: 100, damping: 100 }
												}}
											>
												<Icon type={ICON_BOTTOM} />
											</MotionIconWrapper>
										</>
									)}
								>
									{/* Accordion content */}
									<RichTextRenderer
										data={_item.data.Accordion.accordion_content}
										key="accordion-content"
										additionalClassName="accordion-content"
									/>
								</Collapse>
							)}
						</>
					)}
				</div>
			</SidebarContent>
			{_item.ctaUrl && _item.ctaText && (
				<ButtonWrapper smallerPositionValue="sticky" biggerPositionValue="sticky" webkitSticky>
					<button
						className="btn my-notification-detail-CTA-button"
						data-at="notification-detail-cta-button"
						onClick={() => {
							notificationClickToMyNotificationsDetailPageCTA(
								`${_item.recurringNotificationId ? `r${_item.recurringNotificationId} - ` : ''}${
									_item.id
								} - ${_item.title} - ${_item.ctaUrl}`
							);
							handleCTAClick(_item, router, basePathname);
						}}
					>
						{_item.ctaText}
					</button>
				</ButtonWrapper>
			)}
		</Sidebar>
	);
};

export default NotificationDetail;
